import { render } from "./EditarticleList.vue?vue&type=template&id=2ca21c08&scoped=true"
import script from "./EditarticleList.vue?vue&type=script&lang=js"
export * from "./EditarticleList.vue?vue&type=script&lang=js"

import "./EditarticleList.vue?vue&type=style&index=0&id=2ca21c08&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca21c08"]])

export default __exports__